import { Plugins } from '@leverege/plugin';
import DeleteRsrcBranch from "./DeleteRsrcBranch.js";
import FilterByCreatedAt from "./FilterByCreatedAt.js";
import BulkExportImages from "./BulkExportImages.js";
import TargetGalleryItem from "./TargetGalleryItem.js";
import GenericFlagRsrc from "./GenericFlagRsrc.js";
import ShowEditor from "./ShowEditor.js";
import ShowOverlays from "./ShowOverlays.js";
import CloseSelected from "./CloseSelected.js";
import LayerToggle from "./LayerToggle.js";
function install(plg = Plugins) {
  plg.addPlugin('Action', DeleteRsrcBranch);
  plg.addPlugin('Action', FilterByCreatedAt);
  plg.addPlugin('Action', TargetGalleryItem);
  plg.addPlugin('Action', BulkExportImages);
  plg.addPlugin('Action', GenericFlagRsrc);
  plg.addPlugin('Action', ShowEditor);
  plg.addPlugin('Action', ShowOverlays);
  plg.addPlugin('Action', CloseSelected);
  plg.addPlugin('Action', LayerToggle);
}
export default {
  install
};